// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"fee5753d","50":"db19cff8","311":"db19cff8","545":"d6ce1718","812":"db19cff8","884":"db19cff8","975":"db19cff8"}[chunkId] + ".chunk.css";
};